// extracted by mini-css-extract-plugin
export default {"wrap":"YJrs2n","cell":"TuLSV4","short":"r0bmGb"};